import React, { useMemo } from "react"
import { css, useTheme } from "@emotion/react"
import { withCssUnit } from "@ncs/ts-utils"

export interface ControlLabelEcommProps {
	htmlFor: string
	checked?: boolean
	disabled?: boolean
	top?: number | string
	marginTop?: number | string
	noWrap?: boolean
}

/** For use alongside checkboxes and radio buttons. */
export const ControlLabelEcomm: React.FC<ControlLabelEcommProps> = ({
	htmlFor,
	checked,
	disabled,
	top = "3px",
	marginTop,
	noWrap,
	children,
}) => {
	const theme = useTheme()

	const propsStyle = useMemo(
		() => css`
			top: ${withCssUnit(top)};
			margin-top: 0.4rem;
			opacity: ${disabled ? "0.5" : "1"};
			font-weight: normal;
			color: #374151;
			cursor: ${disabled ? "arrow" : "pointer"};
			white-space: ${noWrap ? "nowrap" : "normal"};
		`,
		[
			checked,
			disabled,
			marginTop,
			top,
			noWrap,
			theme.palette.primary.main,
			theme.palette.text.primary,
		]
	)

	return (
		<label css={[baseStyle, propsStyle]} htmlFor={htmlFor}>
			{children}
		</label>
	)
}

const baseStyle = css`
	position: relative;
`
